import React from 'react';

const CampaignStats = ({ stats, id = 'numeros', ariaLabel }) => (
  <section id={id} className="hhc-numeros" aria-label={ariaLabel}>
    <div className="hhc-num-inner">
      {stats.map((stat, index) => (
        <React.Fragment key={stat.val}>
          {index > 0 && <div className="hhc-num-sep" aria-hidden="true" />}
          <div
            className="hhc-num-item hhc-reveal"
            style={{ transitionDelay: `${index * 0.07}s` }}
          >
            <div className="hhc-num-val">{stat.val}</div>
            <div className="hhc-num-lbl">{stat.lbl}</div>
          </div>
        </React.Fragment>
      ))}
    </div>
  </section>
);

export default CampaignStats;
